
  export default {
    name: 'IndexPage'
  }
